import type { RouteRecordRaw } from 'vue-router'
import ErrorView from '@/views/ErrorView.vue'
import ProjectGeneralPage from '@/views/project/ProjectGeneralPage.vue'
import ProjectServicePage from '@/views/project/ProjectServicePage.vue'
import ProjectSetupPage from '@/views/project/ProjectSetupPage.vue'
import ProjectSummaryPage from '@/views/project/ProjectSummaryPage.vue'
import ProjectVersionUpdatePage from '@/views/project/ProjectVersionUpdatePage.vue'
import OfficeArchitectPage from '@/views/office/OfficeArchitectPage.vue'
import { clientGuard } from '@/router/guards/clientGuard'
import { projectGuard } from '@/router/guards/projectGuard'
import { officeGuard } from '@/router/guards/officeGuard'
import { projectPartGeneralGuard } from '@/router/guards/projectPartGeneralGuard'
import { projectPartRoleGuard } from '@/router/guards/projectPartRoleGuard'
import { projectValidityGuard } from '@/router/guards/project-validity-guard'
import { versionGuard } from '@/router/guards/versionGuard'
import { errorGuard } from '@/router/guards/errorGuard'
import { devGuard } from '@/router/guards/devGuard'
import * as Sentry from '@sentry/vue'

export const routes = (): RouteRecordRaw[] => {
  return [
    {
      path: '/',
      name: 'home',
      redirect: { name: 'general-project-view' },
      // beforeEnter: [clientGuard],
      // component: HomeView // todo - routing between types (project, office) not working
    },
    {
      path: '/project/update',
      name: 'version-update-view',
      beforeEnter: [clientGuard, projectGuard],
      component: ProjectVersionUpdatePage,
      meta: {
        widget: 'project_units',
      },
    },
    {
      path: '/project/general',
      name: 'general-project-view',
      beforeEnter: [clientGuard, projectGuard, projectPartGeneralGuard, versionGuard],
      component: ProjectGeneralPage,
      meta: {
        widget: 'project_units',
      },
    },
    {
      path: '/project/setup/:currentTabIndex?',
      name: 'setup-project-view',
      beforeEnter: [clientGuard, projectGuard, projectPartRoleGuard, projectValidityGuard, versionGuard],
      component: ProjectSetupPage,
      meta: {
        widget: 'project_units',
      },
    },
    {
      path: '/project/service/:currentTabIndex?',
      name: 'service-project-view',
      beforeEnter: [clientGuard, projectGuard, projectPartRoleGuard, projectValidityGuard, versionGuard],
      component: ProjectServicePage,
      meta: {
        widget: 'project_units',
      },
    },
    {
      path: '/project/summary',
      name: 'summary-project-view',
      beforeEnter: [clientGuard, projectGuard, versionGuard],
      component: ProjectSummaryPage,
      meta: {
        widget: 'project_units',
      },
    },
    {
      path: '/office/architect',
      name: 'office-architect',
      beforeEnter: [clientGuard, officeGuard],
      component: OfficeArchitectPage,
      meta: {
        widget: 'office_architect',
      },
    },
    {
      path: '/error/:key', // send translation key for error message
      name: 'error',
      beforeEnter: [errorGuard],
      component: ErrorView,
    },
    {
      path: '/dev/buttons',
      name: 'dev-buttons',
      beforeEnter: [devGuard],
      component: () => import('@/views/dev/ButtonStyleGuidePage.vue'),
    },
    {
      path: '/reload/:path?',
      name: 'reload',
      beforeEnter(to, from, next) {
        Sentry.logger.debug('Entering reload route', { path: String(to.params?.path) })
        if (to.params?.path === 'standalone') {
          // dev only
          next('/')
        } else if (to.params?.path) {
          // set clientFullPath as new route and relaod window to reconnect with api & socket
          window.location.replace(to.params?.path + '&reload=true')
        } else {
          next('/error/no-client')
        }
      },
      component: ErrorView, // we do not relly go here but component is requrired
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: `/404`,
    },
  ]
}
